import * as React from 'react';

import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import MuiAccordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandIcon from '../../assets/expand-more.svg';
import ShrinkIcon from '../../assets/expand-less.svg';

const CustomExpandIcon = () => {
    return (
        <Box>
        <div className="expandIconWrapper icon" style={{ backgroundImage: `url(${ExpandIcon})`}}></div>
        <div className="collapsIconWrapper icon" style={{ backgroundImage: `url(${ShrinkIcon})`}}></div>
        </Box>
    );
};

const Accordion = styled(MuiAccordion)(({ theme }) => ({
    boxShadow: 'none',
    '& .Mui-expanded:not(:first-of-type)::after':{
        position: 'absolute',
        left: '0',
        top: '-1px',
        right: '0',
        height: '1px',
        content: '""',
        opacity: '1',
        backgroundColor: 'rgba(0, 0, 0, 0.12)',
        // -webkitTransition: opacity 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
        transition: 'opacity 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
     },
    '& .root-title .Mui-expanded :before':{
        position: 'absolute',
        left: '0',
        top: '1px',
        right: '0',
        height: '1px',
        content: '""',
        opacity: '1',
        backgroundColor: 'rgba(0, 0, 0, 0.12)',
        // -webkitTransition: opacity 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
        transition: 'opacity 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
     },

  }));

const AccordionNodes = [{
    id: "panel1",
    name: "About Finance Management Associate (FMA) Program",
    children: [{
            id: "panel1a",
            name: "What is the distinction between the Finance Management Associate (FMA) Program and the Sea Global Management Associate Program (GMAP)?",
            desc1: "FMA is a specialized program that focuses on honing specific skills and expertise in the accounting and finance domains within Sea's ecosystem locally and regionally. On the other hand, GMAP offers a broader learning experience with global exposure across our core businesses (Garena, Shopee and SeaMoney).",
            desc2: "<br/>Both programs offer unique opportunities, catering to different career aspirations and pathways. Applicants are encouraged to consider their interests and goals to determine which program aligns best with their professional goals."
        },{
            id: "panel1b",
            name: "How are rotations determined during the two-year program?",
            desc1: "We will take into account your preferences, skill sets, and the business needs when determining the rotations you will take on during the two-year program."
        },{
            id: "panel1c",
            name: "What happens after completing the two-year program?",
            desc1: "Based on your performance during the program, you will be considered for a permanent role. This placement will consider your preferences, team fit, skill sets, and current business needs."
        }
    ]
},{
    id: "panel2",
    name: "About the application process",
    children: [{
        id: "panel2a",
        name: "When can I apply for FMA 2025?",
        desc1: "Applications are open from 15 Aug 2024 to 15 Oct 2024, 23:59 (SGT)."
    },{
        id: "panel2b",
        name: "Can I apply for both the Sea Global Management Associate Program and Finance Management Associate Program?",
        desc1: "You are only allowed to apply for 1 program as each program is targeted at different growth areas. We encourage you to carefully consider your professional interests and career goals before deciding which program to apply for.",
        desc2: "<br/>Learn more about the Global Management Associate Program <a href='http://seamap.sea.com' target='_blank'>here</a>."
    },{
        id: "panel2c",
        name: "I have applied for a specific program but have now decided to choose a different program. What should I do?",
        desc1: "Should you decide to change your selection, please email <a href='mailto:financehr-recruitment@sea.com'>financehr-recruitment@sea.com</a> before the application deadline on 15 Oct 2024. However, do note that requests for change will be considered on a case-by-case basis."
    },]
},{
    id: "panel3",
    name: "About the selection criteria",
    children: [{
        id: "panel3a",
        name: "Is FMA only open to fresh graduates?",
        desc1: "FMA is open to fresh graduates and candidates with less than 2 years of full-time working experience (as of the last day of application window)."
    },{
        id: "panel3b",
        name: "Are you looking for specific majors or educational backgrounds?",
        desc1: "While a Major in accounting is advantageous, we welcome candidates with various educational backgrounds who possess the necessary skill sets and passion for accounting, finance and/or data analytics."
    },{
        id: "panel3c",
        name: "What do you look for in a Management Associate?",
        desc1: "While strong academic performance is valued, we also prioritize specific qualities and characteristics in candidates. We are seeking individuals who are driven, adaptable, and possess effective teamwork and communication skills.",
        desc2: "<br/>Learn more about the selection criteria <a href='#looking-for'>here</a>."
    }]
},{
    id: "panel4",
    name: "About the selection process",
    children: [{
        id: "panel4a",
        name: "Are the interview rounds conducted face-to-face or virtually?",
        desc1: "Most of the interview rounds will be conducted in person. Shortlisted candidates will receive further details about the interview format."
    },{
        id: "panel4b",
        name: "I am currently studying overseas. Can I still apply for FMA?",
        desc1: "Yes, you can still apply for FMA. However, please note that the interviews will be scheduled based on Singapore timezone (GMT +8)."
    },{
        id: "panel4c",
        name: "Is there a limit on the number of Management Associates that Sea Finance is hiring?",
        desc1: "There is no specific limit on the number of Management Associates that Sea Finance is hiring as we value talented individuals."
    },{
        id: "panel4d",
        name: "When can I expect to receive an offer?",
        desc1: "If you are shortlisted for FMA, you can expect to receive an offer by December 2024."
    }]
},{
    id: "panel5",
    name: "Other questions",
    children: [{
        id: "panel5a",
        name: "Who can I contact if I have more questions?",
        desc1: "For further queries, please contact <a href='mailto:financehr-recruitment@sea.com'>financehr-recruitment@sea.com</a>. We look forward to your application!"
    }]
}];


const renderChildren = (children) => {
    return (
        <>
        {children.map((c) => (
        <Accordion key={c.id}>
            <AccordionSummary expandIcon={<CustomExpandIcon />} id={c.id + '-header'} aria-controls={c.id + '-content'} className='child-title'>
                <p>{c.name}</p>
            </AccordionSummary>
            <AccordionDetails className='content'>
                <p dangerouslySetInnerHTML={{__html: c.desc1}}></p>
                {c.desc2 ? <p dangerouslySetInnerHTML={{__html: c.desc2}}></p> : null} 
            </AccordionDetails>
        </Accordion>
        ))}
        </>
    );
};
  
const renderNode = (AccordionNodes) => {
    return (
    <>
    {AccordionNodes.map((an) => (
        <Accordion key={an.id} >
            <AccordionSummary expandIcon={<CustomExpandIcon />} id={an.id + '-header'} aria-controls={an.id + '-content'} className='root-title'>
            <p>{an.name}</p>
            </AccordionSummary>
            <AccordionDetails>
            {renderChildren(an.children)}
            </AccordionDetails>
        </Accordion>
    ))}
    </>
    );
};

function FAQ(){
    return (
        <Box className='wrapper faq' id='FAQ'>
            <h2 className="section-title">You May Want to Find Out...</h2>
            <Box>
                {renderNode(AccordionNodes)}
            </Box>
        </Box>
    );
}
export default FAQ;